import React from 'react'
import { SchemaFormRenderer } from '@components/pages/FormBuilder/Shared/SchemaFormRenderer'
import type { GroupField } from '@components/pages/FormBuilder/types'
import type {
  SchemaFormFieldValues,
  SchemaFormReadOnlyDisplayMode,
} from '@components/pages/FormBuilder/Shared/SchemaFormRenderer'
import './FormPdfCapture.css'

export interface FormPdfCaptureProps {
  groups: GroupField[]
  formTitle: string
  fieldValues: SchemaFormFieldValues
  patientName?: string
  readOnlyDisplayMode?: SchemaFormReadOnlyDisplayMode
}

const FormPdfCapture: React.FC<FormPdfCaptureProps> = ({
  groups,
  formTitle,
  fieldValues,
  patientName,
  readOnlyDisplayMode = 'default',
}) => {
  return (
    <div className="form-pdf-capture-content">
      <SchemaFormRenderer
        groups={groups}
        formTitle={formTitle}
        fieldValues={fieldValues}
        readOnly={true}
        richTextReadOnly={true}
        patientName={patientName}
        readOnlyDisplayMode={readOnlyDisplayMode}
      />
    </div>
  )
}

export default FormPdfCapture
